export default __webpack_public_path__ + "static/media/FilterIcon.d6d2b4e8.svg";